document.addEventListener('DOMContentLoaded', function () {
    let applyButtonClick = document.querySelectorAll('.js-apply-button');
    let applyForm = document.querySelector('.apply-form-js');

    if (applyButtonClick && applyForm) {
        applyButtonClick.forEach(function (el) {
            el.addEventListener('click', function () {
                window.scrollTo({
                    top: applyForm.offsetTop,
                    behavior: 'smooth'
                });
            });
        });
    }

    let anchorButtonClick = document.querySelectorAll('.js-form-anchor');
    let anchorForm = document.querySelector('.apply-form-js');

    if (anchorButtonClick && anchorForm) {
        anchorButtonClick.forEach(function (el) {
            el.addEventListener('click', function () {
                console.log(anchorForm);
                console.log(anchorForm.offsetTop);
                window.scrollTo({
                    top: anchorForm.offsetTop,
                    behavior: 'smooth'
                });
            });
        });
    }

    const scrollDown = document.querySelector('.scrollDown');
    if (scrollDown) {
        scrollDown.style.top = window.innerHeight - 64 + 'px';
        scrollDown.addEventListener('click', (e) => {
            e.preventDefault();

            gsap.to(window, {
                scrollTo: {
                    y: scrollDown.getAttribute('href'),
                    autoKill: false
                },
                duration: 0.5
            });

        })
    }
});

document.addEventListener('DOMContentLoaded', function () {
    function initAcc(elem, option) {
        document.addEventListener('click', function (e) {
            if (!e.target.matches(elem + ' .a-btn')) return;
            else {
                if (!e.target.parentElement.classList.contains('active')) {
                    if (option == true) {
                        var elementList = document.querySelectorAll(elem + ' .a-container');
                        Array.prototype.forEach.call(elementList, function (e) {
                            e.classList.remove('active');
                        });
                    }
                    e.target.parentElement.classList.add('active');
                } else {
                    e.target.parentElement.classList.remove('active');
                }
            }
        });
    }
    initAcc('.accordion.v1', true);
});

function iOS() {
    return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
}

if (iOS()) {
    document.body.classList.add('isIphone');
}
